export default __webpack_public_path__ + "static/media/H1018.5f0c3d33.mp3";